import Header from './HeaderComponent';
import { Component } from 'react';
import {Container, Row, Col,Button, Card, CardImg, CardImgOverlay, CardText, CardBody, CardTitle, Breadcrumb, BreadcrumbItem, Table } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import AddDailyLogForm from './AddDailyLogForm';
import AddTask from './AddTask';
import DailyLogForm from './DailyLogForm';
import AddEditQuestions from './AddEditQuestions';
import { Switch, Redirect, BrowserRouter } from 'react-router-dom';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { DAILYLOG } from '../Shared/dailylog';
import { fetchComments, postComment, postTask } from '../redux/ActionCreators';
import React from 'react';
//import  Dashboard  from './Dashboard';
import "../Shared/styles.css";


// Functional component to render each daily log entry

function RenderDailyLog({ day, postTask, allTasks, timetables, toggleDailyLogFormModal, subject, formattedDate }) {
  const totTasks = day.noOfTasks || 0;
  const tasksText = `${day.noOfDoneTasks || 0}/${totTasks}`;

  // Handle click event to open the daily log form modal
  const handleDailyLogClick = () => {
    //toggleDailyLogFormModal(day.subject, day.date, day.topic, day.subtopic, day.comments, );
    toggleDailyLogFormModal("edit", day.id, day.subject, day.topic, day.subtopic, day.comments, day.date, timetables, allTasks, postTask, day);
  };

  return (
    <div style={{ marginLeft: '100px', textAlign: 'left' }} >
      <CardText style={{ fontSize: 'normal' }} onClick={handleDailyLogClick}>{day.topic + ' > ' + day.subtopic}</CardText>
      <CardText><small className="text-muted">{day.comments}</small></CardText>


    </div>

  );
}


// backup of RenderDailyLog Functional component to render each daily log entry

function RenderDailyLog1({ day, postTask, allTasks, timetables, toggleDailyLogFormModal }) {
  const totTasks = day.noOfTasks || 0;
  const tasksText = `${day.noOfDoneTasks || 0}/${totTasks}`;

  // Handle click event to open the daily log form modal
  const handleDailyLogClick = () => {
    //toggleDailyLogFormModal(day.subject, day.date, day.topic, day.subtopic, day.comments, );
    toggleDailyLogFormModal("edit", day.id, day.subject, day.topic, day.subtopic, day.comments, day.date, timetables, allTasks, postTask, day);
  };

  return (
    <div style={{ marginLeft: '100px' }} onClick={handleDailyLogClick}> {/* Adjust the margin-left as needed */}
      <div style={{ textAlign: 'left' }}>
        <div style={{ fontSize: 'normal' }}>{day.topic + ' > ' + day.subtopic}</div>
        <div style={{ fontSize: 'small' }}>{day.comments}</div>
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  //alert(state.dishes);
  return {
    //dailylogs: state.dailylogs

  }
}

// Map dispatch to props for Redux actions

const mapDispatchToProps = (dispatch) => ({


  postComment: (id, date, subject, topic, subtopic, comments,callback) => dispatch(postComment(id, date, subject, topic, subtopic, comments,callback)),
  postTask: (unique_id, dailylogid, subject, topic, subtopic, comment, date, subtasks, task, duedate) => dispatch(postTask(unique_id, dailylogid, subject, topic, subtopic, comment, date, subtasks, task, duedate))


});

// Class component for DailyLog


class DailyLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDailyLogFormModalOpen: false,
      isDailyPracticeFormModalOpen: false,
      arrSubjectsForDate: [],
      subject: "",
      topic: "",
      subtopic: "",
      comments: "",
      date: "",
      mode: "",
      logid: "",
      timetables: "",
      allTasks: "",
      postTask: "",
      day: ""

    }


    this.fetchSubjectsForDate = this.fetchSubjectsForDate.bind(this);
    this.toggleDailyLogFormModal = this.toggleDailyLogFormModal.bind(this);

  }

  // Method to fetch subjects for a given date based on the timetable
  fetchSubjectsForDate(selectedDate) {
    const tmpSubjects = [];

    //console.log("fetchSubjectsForDate: ", selectedDate)

    this.props.timetables.timetables.forEach(item => {
      const sub = item.subject;
    //  if (sub == "Maths:S-Maths") console.log("fetchSubjectsForDate sub *****************: ", sub)
      item.schedule.forEach(sch => {
        sch.schedule.forEach(day => {
          const startTimeDB = new Date(day.startTime);
          startTimeDB.setHours(0, 0, 0, 0);
          const dateTimeState = new Date(selectedDate);
          dateTimeState.setHours(0, 0, 0, 0);
          // if (sub == "Maths:S-Maths") console.log("fetchSubjectsForDate startTimeDB: ", startTimeDB)
          // if (sub == "Maths:S-Maths") console.log("fetchSubjectsForDate dateTimeState: ", dateTimeState)
          const timeDifference = dateTimeState > startTimeDB ? dateTimeState - startTimeDB : 'NA';
          // if (sub == "Maths:S-Maths") console.log("fetchSubjectsForDate timeDifference: ", timeDifference)

          if (timeDifference !== 'NA') {
            const daysDifference = Math.floor(timeDifference / (24 * 60 * 60 * 1000));
            if (sub == "Maths:S-Maths") console.log(`fetchSubjectsForDate Days difference: ${daysDifference}`);
            const startTimeDbDatePart = startTimeDB.toLocaleDateString();
            const datePartState = dateTimeState.toLocaleDateString();
            if (sub == "Maths:S-Maths") console.log(`fetchSubjectsForDate Start time date part: ${startTimeDbDatePart}, State date part: ${datePartState}`);

            if (daysDifference % (day.repetitionFrequency * 7) === 0 || startTimeDbDatePart === datePartState) {
              if (sub == "Maths:S-Maths") console.log(`fetchSubjectsForDate Adding subject: ${sub} on ${datePartState}`);
              tmpSubjects.push(sub);
            }
          }
        });
      });
    });
    // console.log("fetchSubjectsForDate tmpSubjects: ", tmpSubjects.length)
    return tmpSubjects;
  }


  toggleDailyLogFormModal = (mode, logid, subject, topic, subtopic, comments, formattedDate, timetables, allTasks, postTask, day) => {
    // alert("subject "  + subject);
    // alert("formattedDate "  + formattedDate);
    // alert("mode "  + mode);

    this.setState({
      isDailyLogFormModalOpen: !this.state.isDailyLogFormModalOpen,
      subject: subject,
      topic: topic,
      subtopic: subtopic,
      comments: comments,
      date: formattedDate,
      mode: mode,
      logid: logid,
      timetables: timetables,
      allTasks: allTasks,
      postTask: postTask,
      day: day
    });
  };

  toggleDailyPractice = (mode, logid, subject, topic, subtopic, comments, formattedDate, timetables, allTasks, postTask, day) => {
    // alert("subject "  + subject);
    // alert("formattedDate "  + formattedDate);
    // alert("mode "  + mode);

    this.setState({
      isDailyPracticeFormModalOpen: !this.state.isDailyPracticeFormModalOpen,
      subject: subject,
      topic: topic,
      subtopic: subtopic,
      comments: comments,
      date: formattedDate,
      mode: mode,
      logid: logid,
      timetables: timetables,
      allTasks: allTasks,
      postTask: postTask,
      day: day
    });
  };



  componentDidMount() {


    //this.props.fetchComments(); 


  }



  //console.log(daily);

  render() {

    const dateColumnStyle = {
      paddingLeft: '20px', // Adjust the padding as needed
    };

    const subjectColumnStyle = {
      paddingLeft: '40px', // Adjust the padding as needed
      textAlign: 'left', // Align text to the left
    };

    const dailyLogColumnStyle = {
      paddingLeft: '60px', // Adjust the padding as needed
    };




    const dailyLog = this.props.dailylogs.dailylogs;
    const allTasks = this.props.alltasks.alltasks;
    //const allTasks = this.props.alltasks.alltasks;
    //alert(allTasks);

    // Check if dailyLog or allTasks is undefined or empty
    // if (!dailyLog || dailyLog.length === 0 || !allTasks || allTasks.length === 0) {
    //   return <div>Data is loading</div>;
    // }

    // Get today's date
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set time to midnight

    // Get the start of the year
    const startOfYear = new Date(today.getFullYear(), 0, 1);

    // Generate a list of dates from today till the start of the year
    const dates = [];
    const subjectsByDate = {};
    let currentDate = today; // Initialize with today's date
    const dtDate1 = new Date(currentDate);
    // console.log ("dtDate1 " + dtDate1)
    // const year = dtDate1.getFullYear();
    // const month = (dtDate1.getMonth() + 1).toString().padStart(2, '0');
    // const day = dtDate1.getDate().toString().padStart(2, '0');
    // const formattedDate = `${year}-${month}-${day}`;

    //const formattedDate = dtDate1.toISOString().split('T')[0];
    // console.log ("formattedDate " + formattedDate)
    while (currentDate >= startOfYear) {
      const dtDate = new Date(currentDate);
      const year = dtDate.getFullYear();
      const month = (dtDate.getMonth() + 1).toString().padStart(2, '0');
      const day = dtDate.getDate().toString().padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      //const formattedDate = dtDate.toISOString().split('T')[0];
      // console.log ("in while dtDate " + dtDate);
      // console.log ("in while formattedDate " + formattedDate);
      dates.push(dtDate);
      subjectsByDate[formattedDate] = this.fetchSubjectsForDate(dtDate.setHours(23, 59, 59, 999)); // we have to use sethours with these values so that the calculation is accurate
      currentDate.setDate(currentDate.getDate() - 1); // Decrement the date manually
    }

    //dates.reverse();

    const dailyLogsByDate = {};

    //capture all dailylogs data into an array indexed with date
    dailyLog.forEach(log => {
      const date = new Date(Date.parse(log.date));
      //console.log("date from dailylog: ", date);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;

      //const formattedDate = date.toISOString().split('T')[0];
      //console.log("date from dailylog formattedDate: ", formattedDate);
      dailyLogsByDate[formattedDate] = day;

    });

    /*
    store contents to be displayed on the page into the "daily" variable 
    "dates" = contains all the days starting from today till begining of the year. we loop through these dates
    "dailyLogsByDate" = contains all the entries from dailylog prop indexed by the date of that entry. this is matched with the "dates". 
        if there is a match, the dailylog details from "dailyLogsByDate" are displayed under that date
    
    */

    const daily = dates.map((date, index) => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      const dailyLogEntry = dailyLogsByDate[formattedDate];

      // Render subjects for the current date
      const subjectsForDate = subjectsByDate[formattedDate];
      const subjectsRows = subjectsForDate.map((subject) => {
        // Filter daily log entries for the current subject and date
        // const dailyLogsForSubject = dailyLog.filter((log) => log.subject === subject && new Date(log.date).getFullYear() === formattedDate);

        const dailyLogsForSubject = dailyLog.filter((log) => {
          const logDate = new Date(log.date);
          const logYear = logDate.getFullYear();
          const logMonth = (logDate.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 because getMonth() returns zero-based month index
          const logDay = logDate.getDate().toString().padStart(2, '0');
          const formattedLogDate = `${logYear}-${logMonth}-${logDay}`;

          return log.subject === subject && formattedLogDate === formattedDate;
        });

        // Render daily log entries under the subject
        // const dailyLogsRows = dailyLogsForSubject.map((log) => (
        //   <RenderDailyLog
        //     key={log.id}
        //     day={log}
        //     postTask={this.props.postTask}
        //     allTasks={allTasks}
        //     timetables={this.props.timetables}
        //     toggleDailyLogFormModal={this.toggleDailyLogFormModal}
        //   />
        // ));

        const dailyLogsRows = dailyLogsForSubject.map((log) => (
          <RenderDailyLog
            key={log.id}
            day={log}
            postTask={this.props.postTask}
            allTasks={allTasks}
            timetables={this.props.timetables}
            toggleDailyLogFormModal={this.toggleDailyLogFormModal}
            subject={subject}
            formattedDate={formattedDate}
          />


        ));

        return (
          <React.Fragment key={subject}>
            <Card key={subject} className="daily-log-card">
              <CardBody>
                <CardTitle tag="h6">{subject}<Button outline className="fa fa-pencil fa-lg custom-button" onClick={() => this.toggleDailyLogFormModal("add", "", subject, "", "", "", formattedDate)} >+</Button>
                <Button outline className="fa fa-pencil fa-lg custom-button" onClick={() => this.toggleDailyPractice("add", "", subject, "", "", "", formattedDate)} >Practice</Button>
                </CardTitle>


                {dailyLogsRows}
              </CardBody>



            </Card>

            {/* {subject} &nbsp; */}
            {/* Button to toggle DailyLogForm modal */}
            {/* <Button outline className="fa fa-pencil fa-lg custom-button" onClick={() => this.toggleDailyLogFormModal("add", "", subject, "", "", "", formattedDate)} >+</Button> */}




            {/* Render DailyLogForm with toggleModalCallback prop */}


            {/* {dailyLogsRows} */}
          </React.Fragment>
        );
      });

      return (
        <React.Fragment key={formattedDate}>
          <div key={formattedDate} className="daily-log-date-section">
            <h5 className="daily-log-date">{formattedDate}</h5>

            {subjectsRows.length > 0 ? subjectsRows : (

              <div style={subjectColumnStyle}>No subjects</div>

            )}

            {/* Add a blank row after subjects except for the last date */}
            {

              <div style={subjectColumnStyle}>&nbsp;</div>

            }
          </div>
        </React.Fragment>
      );
    });



    return (
<Container>
                <Row>
                    <Col>
                        <h2 className="my-4">Daily Log</h2>
                      
                        {daily}
                    </Col>
                </Row>

        <DailyLogForm
          isOpen={this.state.isDailyLogFormModalOpen}
          toggleModalCallback={this.toggleDailyLogFormModal}
          logid={this.state.logid}
          subject={this.state.subject} // Pass the subject as a prop
          topic={this.state.topic}
          subtopic={this.state.subtopic}
          comments={this.state.comments}
          date={this.state.date} // Pass the date as a prop
          mode={this.state.mode}// Pass the mode as to add/update          
          postComment={this.props.postComment}
          timetables={this.props.timetables}
          dailylog={this.state.day}
          postTask={this.state.postTask}
          allTasks={this.props.alltasks}

        />

      <AddEditQuestions
          isOpen={this.state.isDailyPracticeFormModalOpen}
          toggleModalCallback={this.toggleDailyPractice}
          logid={this.state.logid}
          subject={this.state.subject} // Pass the subject as a prop
          topic={this.state.topic}
          subtopic={this.state.subtopic}
          comments={this.state.comments}
          date={this.state.date} // Pass the date as a prop
          mode={this.state.mode}// Pass the mode as to add/update          
          postComment={this.props.postComment}
          timetables={this.props.timetables}
          dailylog={this.state.day}
          postTask={this.state.postTask}
          allTasks={this.props.alltasks}
          calledFrom=""

        />        


        {/* <AddDailyLogForm dishId={1} postComment={this.props.postComment} dailylogs={dailyLog} timetables={this.props.timetables} /> */}


        </Container>
    );
  }

}


export default connect(mapStateToProps, mapDispatchToProps)(DailyLog); 